var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8533 10.0007C14.3528 10.0007 14.7501 9.68632 15.1069 9.24677C15.8372 8.34697 14.6381 7.6279 14.1808 7.27574C13.7159 6.91775 13.1969 6.71495 12.6706 6.66734M12.0039 5.334C12.9244 5.334 13.6706 4.58781 13.6706 3.66734C13.6706 2.74686 12.9244 2.00067 12.0039 2.00067",
    stroke: "#DDDDEE",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.15585 10.0007C1.65631 10.0007 1.25899 9.68632 0.902239 9.24677C0.171934 8.34697 1.37099 7.6279 1.82831 7.27574C2.29319 6.91775 2.81226 6.71495 3.33854 6.66734M3.67188 5.334C2.7514 5.334 2.00521 4.58781 2.00521 3.66734C2.00521 2.74686 2.7514 2.00067 3.67188 2.00067",
    stroke: "#DDDDEE",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39441 8.07478C4.71323 8.49598 2.9272 9.35604 4.01501 10.4323C4.54639 10.958 5.13822 11.334 5.88229 11.334H10.1281C10.8722 11.334 11.464 10.958 11.9954 10.4323C13.0832 9.35604 11.2972 8.49598 10.616 8.07478C9.01864 7.08705 6.99178 7.08705 5.39441 8.07478Z",
    stroke: "#DDDDEE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3385 3.00069C10.3385 4.28936 9.29387 5.33403 8.00521 5.33403C6.71654 5.33403 5.67188 4.28936 5.67188 3.00069C5.67188 1.71203 6.71654 0.667358 8.00521 0.667358C9.29387 0.667358 10.3385 1.71203 10.3385 3.00069Z",
    stroke: "#DDDDEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.97b34ff119ad1492886ae15abd575b16.svg";
export { ForwardRef as ReactComponent };